export default "assets/images/logo-30cb65b1.svg";